import api from './api';
import type {
  CargoContract,
  FindCargosQueryContract,
  CargoExameInfoContract,
  CargoExamesResponseContract,
  CargoDetalhesCompletosContract,
  SugerirAtividadesIaPayloadContract,
  SugerirAtividadesIaResponseContract,
  SugerirCboIaResponseContract,
} from '@sstexames/shared-types';

export type Cargo = CargoContract;

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface CreateCargoDto {
  nome: string;
  cbo?: string;
  descricao?: string;
  setor_id?: number;
  cargo_semelhante_id?: number;
  setor_semelhante_id?: number;
  empresa_id?: number;
}

export interface CargoVariacao {
  id: number;
  nome: string;
}

export type CargoExameInfo = CargoExameInfoContract;
export type CargoExamesResponse = CargoExamesResponseContract;

export const cargosService = {
  async findAll(paramsOrLimit?: number | FindCargosQueryContract): Promise<PaginatedResponse<Cargo>> {
    const params = typeof paramsOrLimit === 'number'
      ? { limit: paramsOrLimit }
      : paramsOrLimit || {};
    const response = await api.get<PaginatedResponse<Cargo>>('/cargos', { params });
    return response.data;
  },

  async create(data: CreateCargoDto): Promise<Cargo> {
    const response = await api.post<Cargo>('/cargos', data);
    return response.data;
  },

  async sugerirCboIa(
    cargoNome: string,
    descricao?: string,
  ): Promise<SugerirCboIaResponseContract> {
    const response = await api.post<SugerirCboIaResponseContract>('/cargos/ia/sugerir-cbo', {
      cargo_nome: cargoNome,
      descricao_atividades: descricao,
    });
    return response.data;
  },

  async sugerirAtividadesIa(
    payload: SugerirAtividadesIaPayloadContract,
  ): Promise<SugerirAtividadesIaResponseContract> {
    const response = await api.post<SugerirAtividadesIaResponseContract>('/cargos/ia/sugerir-atividades', payload);
    return response.data;
  },

  async getDetalhesCargo(
    cargoId: number,
    empresaId?: number,
    setorId?: number,
  ): Promise<CargoDetalhesCompletosContract> {
    const response = await api.get<CargoDetalhesCompletosContract>(`/cargos/${cargoId}/detalhes`, {
      params: {
        ...(empresaId ? { empresa_id: empresaId } : {}),
        ...(setorId ? { setor_id: setorId } : {}),
      },
    });
    return response.data;
  },

  async getExamesByCargo(
    cargoId: number,
    empresaId?: number,
    setorId?: number,
    tipoExame?: number | string,
  ): Promise<CargoExamesResponse> {
    const response = await api.get<CargoExamesResponse>(`/cargos/${cargoId}/exames`, {
      params: {
        ...(empresaId ? { empresa_id: empresaId } : {}),
        ...(setorId ? { setor_id: setorId } : {}),
        ...(tipoExame !== undefined && tipoExame !== null && tipoExame !== ''
          ? { tipo_exame: tipoExame }
          : {}),
      },
    });
    return response.data;
  },
};

